/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Grid, Segment, Form, Input,
  Button, Divider, Dimmer, Loader, Container
} from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { changeRouteAction } from "actions/changeActiveItemActions";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";


const UtilsInstance = new Utils();

class AnalyzerDPConfiguration extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      tag: "",
      isTagConfigDimmerActive: false,
      isResetLogDimmerActive: false,
      updateStatus: Constants.NOT_UPDATING,
    };
  }

  showTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: true });
  hideTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: false });

  showResetLogDimmer = () => this.setState({ isResetLogDimmerActive: true });
  hideResetLogDimmer = () => this.setState({ isResetLogDimmerActive: false });

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.tag)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({ tag: resolvedPromisses[0] });
  }

  handleTagChange = (e, { value }) => {
    this.setState({ tag: value });
  }

  sendTag = () => {
    this.showTagConfigDimmer();

    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "tag_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ tag: this.state.tag })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TAG_WAS_CHANGED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TAG_CHANGE_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideTagConfigDimmer);
  }

  cleanLog = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetLogDimmer();

    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "resetLog_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.CLEAN_LOG_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.CLEAN_LOG_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideResetLogDimmer);
  }

  segmentDevices = () => {
    this.props.onChangeRoute(
      this.props.currGenConfigComponent,
      this.props.currProtConfigComponent,
      "segment-devices"
    );
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    const isTagConfigDimmerActive = this.state.isTagConfigDimmerActive;
    const isResetLogDimmerActive = this.state.isResetLogDimmerActive;

    return (
      <Container text>

        <Segment>
          <Divider horizontal>{Strings.TAG_CONFIG_DP}</Divider>
          <Form style={formStyle} onSubmit={this.sendTag}>

            <Form.Field inline>
              <label style={labelStyle}>{Strings.TAG}</label>
              <Input style={inputStyle}
                placeholder={Strings.TEST_NETWORK}
                value={this.state.tag}
                onChange={this.handleTagChange} />
            </Form.Field>

            <Button color="teal" type="submit" >{Strings.SETUP}</Button>
          </Form>
          <Dimmer active={isTagConfigDimmerActive} >
            <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
          </Dimmer>
        </Segment>

        <Grid columns={2} doubling>
          <Grid.Column>
            <Segment>
              <Divider horizontal>{Strings.LOG}</Divider>
              <Button color="teal" onClick={this.cleanLog}>{Strings.CLEAR}</Button>
              <Dimmer active={isResetLogDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment>
              <Divider horizontal>{Strings.IN_SEGMENT_DEVICES}</Divider>
              <Button color="teal" onClick={this.segmentDevices}>{Strings.ALTER}</Button>
            </Segment>
          </Grid.Column>
        </Grid>

      </Container >
    );
  }
}

const mapActionsToProps = {
  onChangeRoute: changeRouteAction,
};

const mapStateToProps = state => ({
  currGenConfigComponent: state.configRoutes.currGenConfigComponent,
  currProtConfigComponent: state.configRoutes.currProtConfigComponent,
  currAnDPConfigComponent: state.configRoutes.currAnDPConfigComponent,
});

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const labelStyle = {
  width: "20%"
};

const inputStyle = {
  width: "70%"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(AnalyzerDPConfiguration));
